/**
 * 配車計画 ドライバー配車 車両
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocations/drivers`

 const allocation_driver_schedule_vehicle = {
  namespaced: true,
  actions: {
    edit ({ commit }, { driver_id, schedule_detail_id, target_date }) {
      let params = { target_date: target_date }
      const api_path = `${API_PATH}/${driver_id}/schedules/${schedule_detail_id}/vehicles/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
    update ({ commit }, { driver_id, schedule_detail_id, params }) {
      const api_path = `${API_PATH}/${driver_id}/schedules/${schedule_detail_id}/vehicles`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
 }

 export default allocation_driver_schedule_vehicle
